import React from "react";
import PropTypes from "prop-types";
import Table from "components/Table";
import UsersWorkspaceTableItem from "layout/userAdmin/users/UsersWorkspaceTableItem";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import plus from "icons/plus-purple.svg";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";

const UsersWorkspaceTable = ({ workspaceId, workspace, users }) => {
  const dispatch = useDispatch();
  const currentAmountOfLicensed = users?.filter((user) => user.licensed).length;

  const header = () => (
    <div
      className="user_admin__container__item__table__header"
      data-testid="users-workspace-table-header"
    >
      <span>Members</span>
      <span>Multiple Workspaces</span>
      <span>First Name</span>
      <span>Last Name</span>
      <span>&nbsp;</span>
      <span>Licensed User</span>
      <span>Edit Dictionaries</span>
      <span>Edit Readability Settings</span>
      <span>Edit Acronym Settings</span>
      <span>Edit Discovery Settings</span>
      <span>Edit Excel Outputs</span>
      <span>Administer Users</span>
      <span>&nbsp;</span>
    </div>
  );

  return (
    <Table
      rows={[
        ...(users
          ? users.map((user) => (
              <UsersWorkspaceTableItem
                firstName={user.firstName}
                lastName={user.lastName}
                readabilitySettings={user.readabilitySettingsAdmin}
                acronymSettings={user.acronymSettingsAdmin}
                discoverySettings={user.discoverySettingsAdmin}
                excelOutputs={user.excelOutputsAdmin}
                dictionary={user.dictAdmin}
                multipleWorkspace={user.workspaces.length > 1}
                userAdmin={user.userAdmin}
                licensed={user.licensed}
                username={user.username}
                workspaceName={workspace}
                workspaceId={workspaceId}
              />
            ))
          : []),
        <div className="user_admin__container__item__table__add__member">
          <Button
            onClick={() => {
              dispatch(
                showModal(modalTypes.ADD_USER_TO_WORKSPACE, {
                  workspaceId,
                  currentAmountOfLicensed,
                })
              );
            }}
            variant={buttonVariants.borderless}
            content={
              <div>
                <img src={plus} alt="plus" />
                <span>Add Member</span>
              </div>
            }
          />
        </div>,
      ]}
      header={header()}
    />
  );
};

export default UsersWorkspaceTable;

UsersWorkspaceTable.propTypes = {
  workspaceId: PropTypes.number.isRequired,
  workspace: PropTypes.string.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      username: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      licensed: PropTypes.bool.isRequired,
      dictAdmin: PropTypes.bool.isRequired,
      readabilitySettingsAdmin: PropTypes.bool.isRequired,
      acronymSettingsAdmin: PropTypes.bool.isRequired,
      discoverySettingsAdmin: PropTypes.bool.isRequired,
      excelOutputsAdmin: PropTypes.bool.isRequired,
      userAdmin: PropTypes.bool.isRequired,
    }).isRequired
  ).isRequired,
};
